import { Injectable } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { Observable } from 'rxjs';
import { ServiceResponse } from '@sdbn/common';
import { DataProtectionRule, DataProtectionRuleDetails } from './data-protection-rules-model';

@Injectable({
  providedIn: 'root'
})
export class DataProtectionRulesService {

  constructor(private appServerAPI: AppServerAPI) { }

  getRules(): Observable<DataProtectionRule[]> {
    return this.appServerAPI.execute<DataProtectionRule[]>('/client/admin/dataprotection', {});
  }

  getDetails(ruleId: number): Observable<DataProtectionRuleDetails> {
    return this.appServerAPI.execute<DataProtectionRuleDetails>('/client/admin/dataprotection/details', ruleId);
  }

  saveDetails(smartphone: DataProtectionRuleDetails): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/dataprotection/save', smartphone);
  }

  deleteRule(ruleId: number): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/dataprotection/delete', ruleId);
  }
}
